import { ReactElement, useEffect, useMemo, useRef, useState } from 'react'
import style from './index.module.less'
import { NavBar, Toast } from 'antd-mobile'
import qs from 'query-string'
import { useHistory } from 'react-router-dom'
import TCPlayer from 'tcplayer.js'
import { getLicenseUrlRequest } from './ajax'
import { awaitWrap } from '@src/assets/js/tool'

async function initData (setData: (v: string) => void): Promise<void> {
  Toast.show({ content: '加载中', icon: 'loading', duration: 0 })
  const [e, d] = await awaitWrap(getLicenseUrlRequest())
  if (e === null && d !== null) {
    Toast.clear()
    setData(d)
  }
}

function Main (): ReactElement {
  const h = useHistory()
  const [licenseUrl, setLicenseUrl] = useState('')
  const videoRef = useRef(null)
  const params = useMemo(() => {
    const s = location.search
    return qs.parse(s)
  }, [])
  useEffect(() => {
    initData(setLicenseUrl).then(null, null)
  }, [])
  useEffect(() => {
    if (typeof params.url === 'string' && params.url !== '' && licenseUrl !== '') {
      const o = TCPlayer('player-container-id', {
        sources: [{
          src: params.url
        }],
        licenseUrl
      })
      return () => {
        o.dispose()
      }
    }
  }, [params, licenseUrl])
  return (
    <div className={style.container}>
      <div className={style.inner}>
        <NavBar onBack={() => { h.goBack() }}>{params.title}</NavBar>
        <div>
          <video ref={videoRef} className={style.player} width={document.documentElement.clientWidth} id="player-container-id" preload="auto" playsInline webkit-playsinline></video>
        </div>
      </div>
    </div>
  )
}

export default Main
